import { ReactNode } from 'react';
import { Text } from '@mercator-gcp/grout';

/**
 * Title bar rendered at the top of a filter sidebar. Shared so every sidebar
 * uses the same type, weight and spacing (Company Search, Filing Search, etc.).
 */

const titleStyle = {
  width: '100%',
  paddingX: 'padding_8',
  paddingTop: 'padding_16',
  paddingBottom: 'padding_8',
};

type SidebarTitleProps = {
  children: ReactNode;
};

export const SidebarTitle = ({ children }: SidebarTitleProps) => {
  return <Text.Lead sx={titleStyle}>{children}</Text.Lead>;
};

export default SidebarTitle;
